import ClientCharge from './ClientCharge'
import ContactClient from './ContactClient'
import ClientFile from './ClientFile'
import CollectionPointPage from './CollectionPointPage'
import ClientGenerator from './client-generator/ClientGenerator'
import ClientResidueGenerator from './client-generator/ClientResidueGenerator'
import ClientCarrier from './ClientCarrier/ClientCarrier'
import ContractClient from './ContractClient'
import ClientMeasurement from './ClientMeasurement.vue'
import { JtCrud } from 'jtech-webcomps'

const { page, pageTable } = JtCrud

export const menu = [
  {
    // Dados do Cliente
    name: 'CUSTOMER_DATA',
    interface: 'client.alterar',
    icon: 'assignment_ind',
    component: page,
    title: 'CUSTOMER_INFO',
    crud: false
  },
  {
    // Dados de Cobrança
    name: 'CHARGE_DATA',
    icon: 'monetization_on',
    interface: 'clientBilling.detalhar',
    component: ClientCharge,
    title: 'CHARGE_INFO',
    crud: false
  },
  {
    // Pontos de Coleta
    name: 'COLLECTION_POINT',
    icon: 'pin_drop',
    interface: 'collectionPoint.detalharPorCliente',
    component: CollectionPointPage,
    title: 'COLLECTION_POINT_CLIENT',
    crud: false
  },
  {
    // Gerador
    name: 'GENERATOR',
    icon: 'local_drink',
    interface: 'clientGenerator.pesquisar',
    component: ClientGenerator,
    title: 'GENERATOR_CLIENT',
    crud: false
  },
  {
    // Gerador x Resíduos
    name: 'GENERATOR_RESIDUE',
    icon: 'local_drink',
    interface: 'clientGeneratorResidue.pesquisar',
    component: ClientResidueGenerator,
    title: 'GENERATOR_CLIENT',
    crud: true
  },
  {
    // Contratos
    name: 'CONTRACTS',
    icon: 'description',
    interface: 'contract.pesquisarClient',
    component: ContractClient,
    title: 'CONTRACTS_INFO',
    crud: true
  },
  {
    // Transportador
    name: 'TRANSPORTER',
    icon: 'local_shipping',
    interface: 'clientCarrier.pesquisar',
    component: ClientCarrier,
    title: 'CARRIER_CLIENT',
    crud: true
  },
  {
    // Contatos
    name: 'CONTACTS',
    icon: 'contact_phone',
    interface: 'contactClient.pesquisar',
    component: ContactClient,
    title: 'CONTACTS_INFO',
    crud: true
  },
  {
    // Arquivos
    name: 'FILES',
    icon: 'insert_drive_file',
    interface: 'clientFile.pesquisarClient',
    component: ClientFile,
    title: 'CUSTOMER_FILES',
    crud: true
  },
  {
    // Medições
    name: 'MEASUREMENTS',
    icon: 'timelapse',
    interface: 'billingOrder.pesquisarMedicao',
    component: ClientMeasurement,
    title: '',
    crud: true
  }
]
